import { render, staticRenderFns } from "./jjqcl.vue?vue&type=template&id=224cda55&scoped=true&"
import script from "./jjqcl.vue?vue&type=script&lang=js&"
export * from "./jjqcl.vue?vue&type=script&lang=js&"
import style0 from "./jjqcl.vue?vue&type=style&index=0&id=224cda55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224cda55",
  null
  
)

export default component.exports